import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const PDFIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M8.334.833h-5a.836.836 0 0 0-.834.834v5c0 .458.375.833.833.833h5a.836.836 0 0 0 .834-.833v-5a.836.836 0 0 0-.833-.834ZM4.792 3.958c0 .346-.28.625-.625.625H3.75v.834h-.625v-2.5h1.042c.346 0 .625.279.625.625v.417Zm2.083.834c0 .346-.279.625-.625.625H5.208v-2.5H6.25c.346 0 .625.279.625.625v1.25Zm1.667-1.25h-.625v.417h.625v.624h-.625v.834h-.625v-2.5h1.25v.625Zm-4.792.417h.417v-.417H3.75v.417ZM1.667 2.5H.833v5.834c0 .458.375.833.834.833H7.5v-.833H1.667V2.5Zm4.167 2.292h.416v-1.25h-.417v1.25Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const PDFIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M8.334.833h-5a.836.836 0 0 0-.834.834v5c0 .458.375.833.833.833h5a.836.836 0 0 0 .834-.833v-5a.836.836 0 0 0-.833-.834ZM4.792 3.958c0 .346-.28.625-.625.625H3.75v.834h-.625v-2.5h1.042c.346 0 .625.279.625.625v.417Zm2.083.834c0 .346-.279.625-.625.625H5.208v-2.5H6.25c.346 0 .625.279.625.625v1.25Zm1.667-1.25h-.625v.417h.625v.624h-.625v.834h-.625v-2.5h1.25v.625Zm-4.792.417h.417v-.417H3.75v.417ZM1.667 2.5H.833v5.834c0 .458.375.833.834.833H7.5v-.833H1.667V2.5Zm4.167 2.292h.416v-1.25h-.417v1.25Z" />
        </SvgIcon>
    );
};
